import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { HelmetProvider } from "react-helmet-async"; // ✅ ADD THIS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>   {/* ✅ ADD THIS */}
    <App />
  </HelmetProvider>
);
